<template>
  <InvoiceParameterDefaultModal
    title="Criar uma regra com status inativo"
    width="560"
    showOctagon
    :show="show"
    @close="setShowCreateRuleInactiveModal(false)">
    <template slot="icon">
    </template>
    <template slot="body">
      <div>
        <TextBase>
          Ative a regra para continuar.
        </TextBase>
        <TextBase>
          Para criar uma nova regra, é necessário ativá-la antes de salvar.
        </TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-center gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="setShowCreateRuleInactiveModal(false)">
          Ok
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapMutations } from 'vuex';
export default {
  name: "CreateRuleInactiveModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  methods: {
    ...mapMutations({
      setShowCreateRuleInactiveModal: 'invoice-parameter/setShowCreateRuleInactiveModal',
    }),
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>